export default "__VITE_ASSET__CTtdG1HG__"